// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Dto
import { TravelInsurancePolicyDto } from 'app/_mapper/travelinsurancepolicy.dto';
import { HealthInsurancePolicyDto } from 'app/_mapper/healthinsurancepolicy.dto';

export class PolicyDto {
    @AutoMap() caseTypeId: string = null;
    @AutoMap() clientId: string = null;
    @AutoMap() isOwnCost: boolean = null;
    @AutoMap() accidentLocation: string = null;
    @AutoMap() countryId: string = null;
    @AutoMap() calamityId: string = null;
    } 